// generate a phpdoc style function description

/*
 * Extracts URL params from a URL
 * 
 * @param {string} url - The URL to extract UTM params from
 * @returns {object} - An object containing the UTM params
 * 
 * @example
 * const utmParams = extractURLParams(window.location.href);
 * 
*/

function extractURLParams(url) {
  const queryString = url.split('?')[1] || '';
  const queryParams = queryString.split('&');
  const utmParams = {};
  queryParams.forEach(queryParam => {
    const [key, value] = queryParam.split('=');
    utmParams[key] = value;
  });

  return utmParams;
}

export default extractURLParams; 